import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@clerk/react-router';

import './Header.css';

const Header = () => { 
  const navigate = useNavigate();
  const { userId } = useAuth();

  const handleClick= () => {
    if (userId) {
      navigate('/dashboard');
    } else {
      navigate('/sign-up');
    }
  }
  return(
    <div id="about" className="app__container">
      <div className="app__wrapper app__flex">
        <div className="app__header app__flex ">
          <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="app__header-info"
          >
            <h1 className="head-text">Ask your partner for <span>anything</span>. <br /> <span>without</span> the fear to say no.</h1>
            <p>Your new custom proposal page, ready in 2 minutes or less.</p>
            <div className="signup-div">
              {userId?(
                <button type="button" className="signup-buttn" onClick={handleClick}>Go To Dashboard</button>
              ):(
                <button type="button" className="signup-buttn" onClick={handleClick}>Create an account Now</button>
              )}
            </div>
          </motion.div>
        </div>
        <motion.div
          whileInView={{ y: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.7 }}
          className="app__header-info"
        >
          <div className="screen">
            <video className="screen-shot" autoPlay muted loop>
              <source src="/video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default Header;
